import React, { Component } from "react";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printer: props.printer,
    };
  }

  render() {
    let printBW = 0;
    let printColor = 0;
    let scan = 0;

    const pricing = this.state.printer.state.computerUser.pricing;

    if (pricing && pricing.print) printBW = Number(pricing.print.bw);
    if (pricing && pricing.print && pricing.print.color)
      printColor = Number(pricing.print.color);
    if (pricing && pricing.scan) scan = pricing.scan;

    return (
      <div
        id="menu-info-bottom"
        className="menu menu-box-bottom"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        <div className="top-20">
          <h2 className="uppercase bold">Info</h2>
          <p className="under-heading bottom-20">Usage pricing</p>
          <div className="center-text-huge bottom-0">
            <table className="table-borders bottom-0" style={{ border: 0 }}>
              <tbody>
                <tr>
                  <th className="bg-highlight">action</th>
                  <th className="bg-highlight">B/W</th>
                  <th className="bg-highlight">Color</th>
                </tr>
                <tr>
                  <td className="bg-highlight">Print/Copy</td>
                  <td>₪ {Number(printBW).toFixed(2)}</td>
                  <td>₪ {Number(printColor).toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="bg-highlight">Scan</td>
                  <td></td>
                  <td>₪ {Number(scan).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <a
            href="#"
            className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight"
          >
            Close
          </a>
        </div>
      </div>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/pages/printer/info.js